import {FormButtonType, FormControlType, IFormConfig, ValidationRules} from 'jobhunter-common-web';

export const addFileFormConfig: typeof IFormConfig = () => ({
    controlType: 'form',
    class: 'default-form',
    dataAccessor: (data: any) => data,
    outputDataMapper: (data: any, previousStateSnapshot: any) => {
        Object.assign(previousStateSnapshot, data);
        return previousStateSnapshot;
    },
    controls: [
        {
            key: 'document',
            controlType: 'group',
            class: 'row',
            controls: {
                document: {
                    hostClass: 'form-control col-xl-12',
                    additionalStyles: 'add-verification-document-input',
                    controlType: 'control',
                    formControlType: FormControlType.FILE_UPLOAD,
                    validationRules: [{name: ValidationRules.IS_REQUIRED}],
                    placeholder: '',
                    label: 'relocationView.files.addFile.form.labels.selectFile',
                    isLabelHidden: false,
                    isFileRemovable: true,
                    acceptedFileExtension: '.pdf',
                    iconSize: 22,
                },
            },
        },
        {
            controlType: 'group',
            key: 'add_document_submit',
            class: 'row',
            controls: {
                submitButton: {
                    controlType: 'control',
                    formControlType: FormControlType.BUTTON,
                    buttonType: FormButtonType.SUBMIT,
                    inputStyles: 'btn btn-primary',
                    hostClass: 'col-xl-12 mb-0',
                    defaultContainerStyles: '',
                    containerStyles: 'button-container mt-2',
                    defaultValue: null,
                    btnText: 'buttons.add',
                },
            },
        },
    ],
});
